//#. Vuex Type Script
//#. Version		          : 1.0.0.0
//#. Template Modified Date : 12-MAR-2020 10:00:00 AM
//#. File Created Date      : 12-MAR-2020 10:00:00 AM
import { Module } from "vuex";
import { RootState } from "../../../../types";
import { About } from "./types";
import { getters } from './getters';
import { mutations } from "./mutations";
import { actions } from "./actions";
const namespaced: boolean = true;

//#. An object containing the data
export const state: About = {
    itemsPerPage: 1,
    dialog: true,
    enabled: false,
    tab: "",
    releaseDetails: "",
    releaseUrl: "",
    releaseDate: "",
    licensee: "",
    buildNumberUrl: '/BuildNumber.xml',
    clientInfoUrl: '/MainMenu/GetClientInfo',
    tabs: ['Application', 'System'],
    system: [
        {
            JavaScript: 'Enabled',
            Cookie: 'Enabled',
            Resolution: '1366 x 768',
            Browser: ''
        }
    ],
    licensor: [
        {
            Build: 'Build Id : 7.0.154.92',
            Modules: 'Version',
            Procurement: '7.0.154.92',
            Sales: '7.0.154.92',
            TimeExpense: '7.0.154.92',
            Administration: '7.0.154.92'
        }
    ],
    application: "PanApps Grants Management System (GMS) is a web based system which gives organizations a solution for creating and managing grant applications."
};

export const RootAbout: Module<About, RootState> = {
    namespaced,
    state,
    getters,
    mutations,
    actions,
};
